<template>
  <!--Utilisation : Just Curio-->
  <article
    class="rc-grid-unit"
    :class="{
      'rc-expired-unit': isExpired(item)
    }"
  >
    <!-- tag -->
    <span v-if="lastChance(item)" class="rc-ribbon rc-ribbon--last-chance">
      <RcIcon name="bell" scale="1.3" /> {{ $t("rights.last_chance.title") }}
    </span>
    <span v-else-if="ribbonTeamPicks" class="rc-ribbon">{{
      $t("common.team_picks")
    }}</span>

    <div v-if="isStacked" class="rc-stack-effect"></div>
    <div class="rc-thumbnail-wrapper" aria-hidden="true">
      <RcImgLazy
        class="img-fluid w-100"
        alt=""
        :src="imgThumbnail(item)"
        @error="imageUrlFallback"
      />
      <span v-if="!isExpired(item)" class="rc-duration">
        {{ useShortDuration(item.duration) }}
      </span>
    </div>

    <header>
      <div class="rc-sur-title">
        <span v-if="item.group_item"> {{ item.group_item.name }}</span>
        <span v-else-if="displayOwnerName(item.content_owner)">
          {{ item.content_owner.name }}
        </span>
      </div>

      <h3 class="h4">
        <template v-if="!locked">
          <router-link
            :to="{
              name: 'catalog.item.detail',
              params: { uid: item.uid, locale: $i18n.locale }
            }"
            class="stretched-link"
            :aria-label="
              $t('catalog.link_label.short', {
                title: item.title,
                duration: useLocaleDuration(item.duration, $i18n.locale)
              })
            "
            @keydown.tab.exact="onKeydownTab"
            @keydown.shift.tab="onKeydownShiftTab"
          >
            {{ item.title }}
          </router-link>
        </template>

        <template v-else>{{ item.title }} </template>
      </h3>
    </header>

    <template v-if="isExpired(item)">
      <div class="rc-tag-end-rights">
        <img :src="icWarningRed" :alt="$t('common.warning')" />{{
          $t("rights.end.tag")
        }}
      </div></template
    ><template v-else
      ><ul class="rc-list-border" role="presentation">
        <li>{{ item.item_type }}</li>
        <li>
          <span class="visually-hidden"
            >{{ $t("catalog.produced_in") }}&nbsp;</span
          >{{ item.year }}
        </li>
        <li v-if="getItemAudiencesShort(item)">
          <span class="visually-hidden"
            >{{ $t("common.recommended_for") }}&nbsp;</span
          >
          {{ $t("catalog.short_audience." + getItemAudiencesShort(item)) }}
        </li>
      </ul></template
    >
  </article>
</template>

<script>
import { catalogItemMixin } from "@/libvue/apps/catalog/mixins/itemMixin";
import RcIcon from "@/libvue/components/icons/Base.vue";
import RcImgLazy from "@/libvue/components/image/ImageLazy.vue";
import {
  useLocaleDuration,
  useShortDuration
} from "@/libvue/composables/durations";
import icWarningRed from "#/assets/img/icons/ic_warning_red.svg";

export default {
  name: "RcGridUnit",
  components: {
    RcIcon,
    RcImgLazy
  },
  mixins: [catalogItemMixin],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    locked: {
      type: Boolean,
      default: false
    },
    isStacked: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ["keydownTab", "keydownShiftTab"],
  setup() {
    return { useLocaleDuration, useShortDuration, icWarningRed };
  },
  computed: {
    ribbonTeamPicks() {
      return (
        this.item.featured &&
        !["catalog.featured.detail", "catalog.item.detail"].includes(
          this.$route.name
        )
      );
    }
  },
  methods: {
    onKeydownTab(e) {
      this.$emit("keydownTab", e);
    },
    onKeydownShiftTab(e) {
      this.$emit("keydownShiftTab", e);
    }
  }
};
</script>
